import styled from 'styled-components';

export const MainContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.base.background};
  * {
    box-sizing: border-box;
  }
`;
